export function getLocaleLanguage () {
    let lang = 'en';
    try {
        lang = navigator.language || window.navigator.language;
        console.log('getLocaleLanguage(): ', lang);
        if (lang === 'zh-TW') {
            lang = 'zh-HK';
        }

        if (lang.indexOf('zh') === -1) {
            lang = lang.split('-')[0];
        }
    } catch (err) {
        lang = 'en';
    }
    return lang.toLowerCase();
}

function init () {
    this.locale = getLocaleLanguage();
    this.getSpecDetails();

    if (window.location.href.indexOf('oauthTalking') !== -1) {
        return;
    }
}

export default init;